import { Injectable } from '@angular/core';
import { Observable, of, forkJoin, from, throwError } from 'rxjs';
import { AuthService, LanguageService } from '..';
import { Location } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HTTP_HEADER_CONTENT_TYPE, MIME_TYPE_JSON, MULTIPART_FORM_DATA, HTTP_HEADER_AUTHORIZATION, HTTP_HEADER_ESC_USER_DETAIL, HTTP_HEADER_ESC_TIMEZONE } from '../../utils/constant';
import { environment } from '../../../environments/environment';
import { CognitoUserSession } from 'amazon-cognito-identity-js';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DialogService } from '../dialog/dialog.service';
import { API, Signer } from 'aws-amplify'

import * as urlLib from 'url';
import * as _ from 'lodash';
import * as moment from 'moment';

interface HttpOption {
  body?: any;
  queryStringParameters?: any;
  headers?: any;
  isPrivate?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private apiEndpoint = environment.api.endpoints[0].endpoint;
  private apiName = environment.api.endpoints[0].name;

  constructor(
    private router: Router,
    private http: HttpClient,
    private authService: AuthService,
    private dialogService: DialogService,
    private languageService: LanguageService,
  ) { }

  // public get(urlPath: string, httpParams?: any, additionalHeaders: any = { observe: 'body' }): Observable<any> {
  //   let params: any = {};

  //   return this.authService.getUserSession().pipe(
  //     catchError((err) => {
  //       if (_.get(err, 'code') === "NotAuthorizedException") {
  //         this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
  //         this.authService.clearCredentials();
  //         this.router.navigate(['/login']);
  //       }
  //       return of(err);
  //     }),
  //     switchMap((session: any) => {

  //       let url = new URL(urlPath, this.apiEndpoint);

  //       let headers = _.assign({}, additionalHeaders, {
  //         [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
  //         [HTTP_HEADER_AUTHORIZATION]: session.getIdToken().getJwtToken(),
  //         [HTTP_HEADER_ESC_USER_DETAIL]: localStorage.getItem("userDetails"),
  //         [HTTP_HEADER_ESC_TIMEZONE]: localStorage.getItem("escTimezone")
  //       });
        
  //       if (url.pathname.includes('login')) {
  //         console.log("PASOK sa login")
  //         delete headers[HTTP_HEADER_ESC_USER_DETAIL];
  //         delete headers[HTTP_HEADER_ESC_TIMEZONE];
  //       }

  //       let httpOptions = _.assign({
  //         headers: new HttpHeaders(headers),
  //         params: new HttpParams({
  //           fromObject: httpParams
  //         })
  //       }, additionalHeaders);
        
  //       //send firebase token in headers during login only
  //       // NOTE by ACE balik mo lng pag need ng firebase
  //       // if(url.pathname.includes('login') || url.pathname.includes('callback')) {
  //       //   httpOptions = _.assign({
  //       //     headers: new HttpHeaders({
  //       //       [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
  //       //       [HTTP_HEADER_AUTHORIZATION]: session.getIdToken().getJwtToken(),
  //       //     }),
  //       //     params: new HttpParams({
  //       //       fromObject: httpParams
  //       //     })
  //       //   }, additionalHeaders)

  //       //   delete httpParams['pushToken'];
  //       // }


  //       if (environment.showLogs) {
  //         console.log("get", url, httpParams, httpOptions.headers, moment().format('HH:mm:ss'));
  //       }

  //       return this.http.get(url.toString(), httpOptions).pipe(
  //         catchError((err) => {
  //           if (_.get(err, 'status') === 401) {
  //             this.authService.logout();
  //             this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
  //             this.router.navigate(['/login']);
  //           }
  //           return of(err);
  //         })
  //       );
  //     })
  //   )
  // }
  //NOTE by ACE: balik mo to pag di gumana yung isang post method na nag checheck ng session
  // public get<T>(path, httpParams?, additionalHeaders?): Observable<T[] | T | any> {
  //   let result;

  //   this.authService.checkAWSCredentials(response => {
  //     if (response) {
  //       console.log("Token error. ", response);
  //       return response = of(response);
  //     }
  //   })

  //   result = this.authService.user.cognitoUser.getSession((err, session: CognitoUserSession) => {
  //     if (err) {
  //       return result = of(err);
  //     }

  //     let url = new URL(path, this.apiEndpoint);

  //     let headers = _.assign({}, additionalHeaders, {
  //       [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
  //       [HTTP_HEADER_AUTHORIZATION]: session.getIdToken().getJwtToken(),
  //       [HTTP_HEADER_ESC_USER_DETAIL]: localStorage.getItem("userDetails"),
  //       [HTTP_HEADER_ESC_TIMEZONE]: localStorage.getItem("escTimezone")
  //     });

  //     if(url.pathname.includes('login')) {
  //       delete headers[HTTP_HEADER_ESC_USER_DETAIL];
  //       delete headers[HTTP_HEADER_ESC_TIMEZONE];
  //     }

  //     if (environment.showLogs) {
  //       console.log("get", url, httpParams, headers);
  //     }

  //     return result = this.http.get<T[] | T>(url.toString(), {
  //       headers: new HttpHeaders(headers),
  //       params: httpParams
  //     }).pipe(
  //       catchError((err) => {
  //         if (_.get(err, 'status') === 401) {
  //           this.authService.logout();
  //           this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
  //           this.router.navigate(['/login']);
  //         }
  //         return of(err);
  //       })
  //     );
  //   })
  //   return result;
  // }


  //NOTE by ACE: balik mo to pag di gumana yung isang post method na nag checheck ng session
  // public post<T>(path, data?, additionalHeaders?): Observable<T[] | T | any> {
  //   let result;

  //   this.authService.checkAWSCredentials(response => {
  //     if (response) {
  //       console.log("Token error. ", response);
  //       return response = of(response);
  //     }
  //   })

  //   result = this.authService.user.cognitoUser.getSession((err, session: CognitoUserSession) => {
  //     if (err) {
  //       return result = of(err);
  //     }

  //     let url = new URL(path, this.apiEndpoint);

  //     let headers = _.assign({}, additionalHeaders, {
  //       [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
  //       [HTTP_HEADER_AUTHORIZATION]: session.getIdToken().getJwtToken(),
  //       [HTTP_HEADER_ESC_USER_DETAIL]: localStorage.getItem("userDetails"),
  //       [HTTP_HEADER_ESC_TIMEZONE]: localStorage.getItem("escTimezone")
  //     });

  //     if (environment.showLogs) {
  //       console.log("post", url.href, data, headers);
  //     }

  //     return this.http.post<T[] | T>(url.toString(), data, {
  //       headers: new HttpHeaders(headers)
  //     }).pipe(
  //       catchError((err) => {
  //         if (_.get(err, 'status') === 401) {
  //           this.authService.logout();
  //           this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
  //           this.router.navigate(['/login']);
  //         }
  //         return of(err);
  //       })
  //     );
  //   })

  //   return result;
  // }

  public get(urlPath: string, httpParams?: any, additionalHeaders: any = { observe: 'body' }): Observable<any> {
    let params: any = {};
 
    return this.authService.getUserSession().pipe(
      catchError((err) => {
        if (_.get(err, 'code') === "NotAuthorizedException") {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
          this.authService.clearCredentials();
          this.router.navigate(['/login']);
        }
        return of(err);
      }),
      switchMap((session: any) => {
        let httpOptions = _.assign({
          headers: new HttpHeaders({
            "Authorization": session.getIdToken().getJwtToken()
          }),
          params: new HttpParams({
            fromObject: httpParams
          })
        }, additionalHeaders);
​
        let url = new URL(urlPath, this.apiEndpoint);
​
        //send firebase token in headers during login only
        if(url.pathname.includes('login') || url.pathname.includes('callback')) {
          httpOptions = _.assign({
            headers: new HttpHeaders({
              [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
              [HTTP_HEADER_AUTHORIZATION]: session.getIdToken().getJwtToken(),
            }),
            params: new HttpParams({
              fromObject: httpParams
            })
          }, additionalHeaders)
          
          delete httpParams['pushToken'];
        }else{

        httpOptions = _.assign({
          headers: new HttpHeaders({
            [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
            [HTTP_HEADER_AUTHORIZATION]: session.getIdToken().getJwtToken(),
            [HTTP_HEADER_ESC_USER_DETAIL]: localStorage.getItem("userDetails"),
            [HTTP_HEADER_ESC_TIMEZONE]: localStorage.getItem("escTimezone")
          }),
          params: new HttpParams({
            fromObject: httpParams
          })
        }, additionalHeaders)
        
        delete httpParams['pushToken'];
        }
  
        if (environment.showLogs) {
          console.log("get", url, httpParams, httpOptions.headers, moment().format('HH:mm:ss'));
        }
        
        return this.http.get(url.toString(), httpOptions).pipe(
          catchError((err) => {
            if (_.get(err, 'status') === 401) {
              this.authService.logout();
              this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
              this.router.navigate(['/login']);
            }
            return of(err);
          })
        );
      })
    )
  }

  public post(urlPath: string, data?: any, options: any = { observe: 'body' }): Observable<any> {
    return this.authService.getUserSession().pipe(
      catchError((err) => {
        if (_.get(err, 'code') === "NotAuthorizedException") {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
          this.authService.clearCredentials();
          this.router.navigate(['/login']);
        }
        return of(err);
      }),
      switchMap((session: any) => {
        let httpOptions = _.assign({
          headers: new HttpHeaders({
            [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
            [HTTP_HEADER_AUTHORIZATION]: session.getIdToken().getJwtToken(),
            [HTTP_HEADER_ESC_USER_DETAIL]: localStorage.getItem("userDetails"),
            [HTTP_HEADER_ESC_TIMEZONE]: localStorage.getItem("escTimezone")
          })
        }, options);
        let url = new URL(urlPath, this.apiEndpoint);
        //NOTE by ACE balik mo lng pag need ng firebase
        // if(url.pathname.includes('login') || url.pathname.includes('callback')) {
        //   httpOptions = _.assign({
        //     headers: new HttpHeaders({
        //       [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
        //       [HTTP_HEADER_AUTHORIZATION]: session.getIdToken().getJwtToken(),
        //     })
        //   }, options);
        //   delete data['pushToken'];
        // }
        if (environment.showLogs) {
          console.log("post", url.href, data, httpOptions.headers, moment().format('HH:mm:ss'));
        }
        return this.http.post(url.toString(), data, httpOptions).pipe(
          catchError((err) => {
            if (_.get(err, 'status') === 401) {
              this.authService.logout();
              this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
              this.router.navigate(['/login']);
            }
            return of(err);
          })
        );
      })
    )
  }

  public getImages(url) {
    let result;
    result = this.authService.user.cognitoUser.getSession((err, session: CognitoUserSession) => {
      if (err) {
        return result = of(err);
      }

      let headers = _.assign({}, {
        [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
        [HTTP_HEADER_AUTHORIZATION]: session.getIdToken().getJwtToken()
      });

      return result = this.http.get(url.toString(), {
        headers: new HttpHeaders(headers),
        responseType: 'blob'
      }).pipe(
        catchError((err) => {
          if (_.get(err, 'status') === 401) {
            this.authService.logout();
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
            this.router.navigate(['/login']);
          }
          return of(undefined);
        }),
      );
    })
    return result;
  }

//   public public_get(urlPath: string, httpParams?: any, additionalHeaders: any = { observe: 'body' }): Observable<any> {
//     let httpOptions = _.assign({
//       headers: new HttpHeaders({
//         [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
//       }),
//       params: new HttpParams({
//         fromObject: httpParams
//       })
//     }, additionalHeaders);
// ​
//     let url = new URL(urlPath, this.apiEndpoint);
        
//     return this.http.get(url.toString(), httpOptions).pipe(
//       catchError((err) => {
//         if (_.get(err, 'status') === 401) {
//           this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
//         }
//         return of(err);
//       })
//     );
//   }

  // public public_post(urlPath: string, data?: any, options: any = { observe: 'body' }): Observable<any> {
  //   let httpOptions = _.assign({
  //     headers: new HttpHeaders({
  //       [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON
  //     })
  //   }, options);

  //   let url = new URL(urlPath, this.apiEndpoint);
       
  //   return this.http.post(url.toString(), data, httpOptions).pipe(
  //     catchError((err) => {
  //       if (_.get(err, 'status') === 401) {
  //         this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_SESSION_TIMEOUT", {}));
  //       }
  //       return of(err);
  //     })
  //   );
  // }

  private getEndpoint() {
    return from(API.endpoint(this.apiName))
  }

  private init(method: string, path: string, { body = null, queryStringParameters = {}, headers = {} }) {
    // This ensure that the user is using the unauthenticated role
    this.authService.logoutSilent();

    let init = {
      headers: headers,
      queryStringParameters: queryStringParameters,
      body: body
    };

    return forkJoin([
      this.authService.getEssentialCredentials(),
      this.getEndpoint()
    ]).pipe(
      switchMap(([credentials, endpoint]) => {
        const cred = {
          secret_key: credentials.secretAccessKey,
          access_key: credentials.accessKeyId,
          session_token: credentials.sessionToken
        }
        // console.log(cred)

        const url = Location.joinWithSlash(endpoint, path);
        const parsedUrl = urlLib.parse(url, true, true);
        const formattedUrl = urlLib.format({
          ...parsedUrl,
          query: queryStringParameters
        });
        // console.log(formattedUrl)

        const serviceInfo = {
          region: 'ap-southeast-1', service: 'execute-api'
        }

        let params: any = {
          headers: {
            'Content-Type': MIME_TYPE_JSON,
          },
          method: method,
          url: formattedUrl
        }

        if (body) {
          params.data = JSON.stringify(body)
        }

        // Signer.sign takes care of all other steps of Signature V4
        let signedReq = Signer.sign(params, cred, serviceInfo);

        // Resolve Error: Refused to set unsafe header "host"
        signedReq.headers['host'] = null;

        init.headers = signedReq.headers;
        return of(init);
      })
    )
  }

  public_get(path, options: HttpOption = { queryStringParameters: {}, headers: {} }) {
    return this.init('GET', path, options).pipe(
      switchMap(init => {
        return from(API.get(this.apiName, path, init)).pipe(
          catchError((err) => {
            return throwError(err);
          })
        );
      })
    )
  }

  public_post(path, options: HttpOption = { body: null, queryStringParameters: {}, headers: {} }) {
    return this.init('POST', path, options).pipe(
      switchMap(init => {
        return from(API.post(this.apiName, path, init)).pipe(
          catchError((err) => {
            return throwError(err);
          })
        );
      })
    )
  }

}
